export default __webpack_public_path__ + "static/media/BM_RenderCamera_01_Kitchen+Interior+Light_Scheme+Kitchen.7d93f034.jpg";